import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { map, catchError} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from './cookie-management.service';
import { changeEmailModel } from '../models/changeEmail.model';
import { putAccountConfirmServerResModel } from '../models/serverResponse.model';
import { putAccountConfirmServiceResModel } from '../models/serviceResponse.model';
import { AppConfig } from 'src/app/config-service/app.config';
import { VersionHelper } from 'src/app/utility-packages/versionHelper/version-helper';


@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  constructor(
    private http: HttpClient, 
    private translate: TranslateService, 
    private cookieManagementService: CookieManagementService,
    private versionHelper: VersionHelper
    ) { }

  public postConfirm(obChangeEmail: changeEmailModel): Observable<any>{
    let url = AppConfig.settings.apiServer.url + 'api/v4.0/account/confirm?region=' + AppConfig.settings.city.region + '&authType=' + AppConfig.settings.apiServer.authType + '&version=' + this.versionHelper.getVersion() + '&lang=' + this.cookieManagementService.getlanguage();
    
    let accessToken = this.cookieManagementService.getAccessToken();
    if(accessToken == ''){
      return throwError(this.translate.instant('ACCOUNT_ACCOUNT_NOT_FOUND_TOKEN'));
    }

    let body = {
      ref_no: obChangeEmail.refNo,
      otp_code: obChangeEmail.otpCode
    }

    return this.http.post<putAccountConfirmServerResModel>(url, body, {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + accessToken
      }),
      responseType: 'json'
    }).pipe(
      map((response: putAccountConfirmServerResModel) => {
        try{
          if(response && response.result){
            if(response && response.result){
              if(response.result.hasOwnProperty('code') && response.result.code === 0){
                return new putAccountConfirmServiceResModel(false, '');
              }
              else if(response.result.hasOwnProperty('code') && response.result.code !== 0 && response.result.message){
                return new putAccountConfirmServiceResModel(true, response.result.message);
              }
              else{
                return new putAccountConfirmServiceResModel(true, this.translate.instant('DEFAULT_ERROR_MESSAGE'));    
              }
            }
            else{
              return new putAccountConfirmServiceResModel(true, this.translate.instant('DEFAULT_ERROR_MESSAGE'));  
            }
          }
          else{
            return new putAccountConfirmServiceResModel(true, this.translate.instant('DEFAULT_ERROR_MESSAGE'));  
          }
        }
        catch(err){
          return new putAccountConfirmServiceResModel(true, this.translate.instant('DEFAULT_ERROR_MESSAGE'));
        }
      }),
      catchError( error => {
        if(typeof error === 'string'){
          return throwError(error);
        }
        else{
          return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
        }
      })
    )
  };
}
